module.exports = __webpack_public_path__ + "img/vip3.c468f299.png";